module.exports = __webpack_public_path__ + "static/media/filterIcon.51aad8bb.svg";